"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketMetadata = exports.SocketTimingInfo = exports.ClientErrorInProgress = exports.TlsMetadata = exports.LastTunnelAddress = exports.LastHopEncrypted = exports.TlsSetupCompleted = exports.InitialRemotePort = exports.InitialRemoteAddress = void 0;
// We store a bunch of metadata that we directly attach to sockets, TLS
// sockets, and HTTP/2 streams to track our state over time & through tunneling:
exports.InitialRemoteAddress = Symbol('initial-remote-address');
exports.InitialRemotePort = Symbol('initial-port-address');
exports.TlsSetupCompleted = Symbol('tls-setup-comleted');
exports.LastHopEncrypted = Symbol('last-hop-encrypted');
exports.LastTunnelAddress = Symbol('last-hop-address');
exports.TlsMetadata = Symbol('tls-metadata');
exports.ClientErrorInProgress = Symbol('client-error-in-progress');
exports.SocketTimingInfo = Symbol('socket-timing-info');
exports.SocketMetadata = Symbol('socket-metadata');
//# sourceMappingURL=socket-extensions.js.map